import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import Box from "../../../components/Box";
import { Helpers } from "../../../helpers/Helpers";
import { KTCard } from "../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../_metronic/helpers/components/KTCardBody";
import Content from "../../../_metronic/layout/components/content/Content";
import { ToolbarWrapper } from "../../../_metronic/layout/components/toolbar";
import { PageTitle } from "../../../_metronic/layout/core";
import { useNavigate, useSearchParams } from "react-router-dom";
import { storeActivityIndicator } from "../../../redux/reducers/authSlice";
import toast from "react-hot-toast";
import CustomSingleSelect, { CustomSingleSelectModel } from "../../../components/CustomSingleSelect";
import PageHeader from "../../../components/PageHeader";
import { ConstantService } from "../../../services/ConstantService";
import { AntrepoExitTypeEnum, ProductTypeEnum } from "../../../models/common/Enums";
import { GetConstantListResponse } from "../../../models/response/constant/GetConstantListResponse";
import { GetWelcomeListResponseData } from "../../../models/response/welcome/GetWelcomeListResponse";
import { AntrepoOutService } from "../../../services/AntrepoOutService";
import { AntrepoInService } from "../../../services/AntrepoInService";
import { GetAntrepoInByIdResponse, GetAntrepoInByIdResponseAntrepoInVehicleProduct, GetAntrepoInByIdResponseData } from "../../../models/response/antrepoIn/GetAntrepoInByIdResponse";
import moment from "moment";
import GeneralInformation from "./Components/GeneralInformation";
import { AddAntrepoOutRequest, AddAntrepoOutRequestAntrepoOutVehicle, AddAntrepoOutRequestAntrepoOutVehicleProduct } from "../../../models/request/antrepoOut/AddAntrepoOutRequest";
import { AddAntrepoOutResponse } from "../../../models/response/antrepoOut/AddAntrepoOutResponse";
import { GetAntrepoOutByIdResponse, GetAntrepoOutByIdResponseAntrepoOutLock, GetAntrepoOutByIdResponseAntrepoOutMessage, GetAntrepoOutByIdResponseAntrepoOutVehicle, GetAntrepoOutByIdResponseAntrepoOutVehicleProduct, GetAntrepoOutByIdResponseAntrepoOutVehicleService, GetAntrepoOutByIdResponseFileArchive } from "../../../models/response/antrepoOut/GetAntrepoOutByIdResponse";
import VehicleInformation from "./Components/VehicleInformation";
import ProductInformation from "./Components/ProductInformation";
import ServicesInformation from "./Components/ServicesInformation";
import FileArchives from "./Components/FileArchives";
import { GetAntrepoOutListByAntrepoInIdResponse } from "../../../models/response/antrepoOut/GetAntrepoOutListByAntrepoInIdResponse";
import { GetConstantByIdResponse } from "../../../models/response/constant/GetConstantByIdResponse";
import AntrepoIns from "./Components/AntrepoIns";
import { RootState } from "../../../redux/store";
import { useSelector } from "react-redux";
import CustomTextInput from "../../../components/CustomTextInput";
import TransferInformation from "./Components/TransferInformation";
import { AddAntrepoInResponse } from "../../../models/response/antrepoIn/AddAntrepoInResponse";
import { AddAntrepoInRequest, AddAntrepoInRequestAntrepoInVehicle, AddAntrepoInRequestAntrepoInVehicleProduct, AddAntrepoInRequestAntrepoInVehicleService } from "../../../models/request/antrepoIn/AddAntrepoInRequest";
import { GetAntrepoInByTransferAntrepoOutIdResponse } from "../../../models/response/antrepoIn/GetAntrepoInByTransferAntrepoOutIdResponse";
import MessageHistory from "./Components/MessageHistory";

interface InOutModel {
    gTipId: string | undefined
    potQuantitySum: number,
    grossWeightSum: number,
    netWeightSum: number,
    volumeSum: number,
    areaSum: number,
}

const AntrepoOutAdd = () => {
    const auth = useSelector((state: RootState) => state.auth)
    const navigate = useNavigate();
    const pageName = "Antrepo Modülü > Antrepo Çıkışı"
    const [searchParams, setSearchParams] = useSearchParams();
    const dispatch = useDispatch();
    const generalInformationRef: any = useRef();
    const dateInformationRef: any = useRef();
    const firmInformationRef: any = useRef();
    const transferInformationRef: any = useRef();
    const vehicleInformationRef: any = useRef();
    const productInformationRef: any = useRef();
    const serviceInformationRef: any = useRef();
    const fileArchivesRef: any = useRef();
    const antrepoInsRef: any = useRef();
    const antrepoOutMessagesRef: any = useRef();

    const [antrepoOutId, setAntrepoOutId] = useState<string | undefined>(undefined);

    const [ledgerNo, setLedgerNo] = useState<string | undefined>(undefined);
    const [antrepoDeclarationNo, setAntrepoDeclarationNo] = useState<string | undefined>(undefined);
    const [antrepoDeclarationDate, setAntrepoDeclarationDate] = useState<string | undefined>(undefined);
    const [goodsAmount, setGoodsAmount] = useState<string | undefined>(undefined);
    const [selectedGoodsAmountCurrencyType, setSelectedGoodsAmountCurrencyType] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [guaranteeAmount, setGuaranteeAmount] = useState<string | undefined>(undefined);
    const [selectedGuaranteeAmountCurrencyType, setSelectedGuaranteeAmountCurrencyType] = useState<CustomSingleSelectModel | undefined>(undefined);

    const [selectedSenderFirm, setSelectedSenderFirm] = useState<CustomSingleSelectModel | undefined>(undefined);

    const [receiptNo, setReceiptNo] = useState<string | undefined>(undefined);
    const [receiptDate, setReceiptDate] = useState<string | undefined>(undefined);
    const [antrepoInId, setAntrepoInId] = useState<string | undefined>(undefined);

    const [antrepoOutVehicles, setAntrepoOutVehicles] = useState<GetAntrepoOutByIdResponseAntrepoOutVehicle[]>([]);
    const [antrepoOutVehicleProducts, setAntrepoOutVehicleProducts] = useState<GetAntrepoOutByIdResponseAntrepoOutVehicleProduct[]>([]);
    const [antrepoOutVehicleServices, setAntrepoOutVehicleServices] = useState<GetAntrepoOutByIdResponseAntrepoOutVehicleService[]>([]);
    const [fileArchives, setFileArchives] = useState<GetAntrepoOutByIdResponseFileArchive[]>([]);

    const [welcomeList, setWelcomeList] = useState<GetWelcomeListResponseData[]>([]);

    const [selectedProductType, setSelectedProductType] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [defaultProductType, setDefaultProductType] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [antrepoInVehicleProducts, setAntrepoInVehicleProducts] = useState<GetAntrepoInByIdResponseAntrepoInVehicleProduct[]>([]);
    const [isPartial, setIsPartial] = useState(false);

    const [declarationPotQuantity, setDeclarationPotQuantity] = useState<string | undefined>(undefined);
    const [declarationPotWeight, setDeclarationPotWeight] = useState<string | undefined>(undefined);

    const [selectedReceiverFirm, setSelectedReceiverFirm] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedExitType, setSelectedExitType] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [defaultAntrepoDeclarationNo, setDefaultAntrepoDeclarationNo] = useState('');
    const [selectedCustomsDirectorate, setSelectedCustomsDirectorate] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [antrepoIn, setAntrepoIn] = useState<GetAntrepoInByIdResponseData | undefined>(undefined);

    const [antrepoOutLocks, setAntrepoOutLocks] = useState<GetAntrepoOutByIdResponseAntrepoOutLock[]>([]);
    const [antrepoOutMessages, setAntrepoOutMessages] = useState<GetAntrepoOutByIdResponseAntrepoOutMessage[]>([]);
    const [selectedLockReason, setSelectedLockReason] = useState<CustomSingleSelectModel | undefined>(undefined);

    const [isLocked, setIsLocked] = useState(false);
    const [isDisabledFromLock, setIsDisabledFromLock] = useState(false);

    const [defaultLockReason, setDefaultLockReason] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [unlockReason, setUnlockReason] = useState<string | undefined>('');

    const [selectedTransferFirm, setSelectedTransferFirm] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [transferAntrepoDeclarationNo, setTransferAntrepoDeclarationNo] = useState<string | undefined>(undefined);
    const [transferAntrepoDeclarationDate, setTransferAntrepoDeclarationDate] = useState<string | undefined>(undefined);
    const [selectedDutyFirm, setSelectedDutyFirm] = useState<CustomSingleSelectModel | undefined>(undefined);

    const [transferWithExpenses, setTransferWithExpenses] = useState(false);
    const [justTransfer, setJustTransfer] = useState(false);

    useEffect(() => {
        var id = searchParams.get("id");
        getData(id);
    }, [])

    const getData = async (_id: string | undefined | null = undefined, _lastSelectedOne: string | undefined = undefined) => {
        try {
            dispatch(storeActivityIndicator(true));

            var antrepoInId = searchParams.get("antrepoInId");
            var _isPartial = searchParams.get("isPartial");
            var id = _id ? _id : searchParams.get("id") ? searchParams.get("id") : undefined;
            var exitTypeId = searchParams.get("exitTypeId");

            if (_isPartial)
                setIsPartial(_isPartial == "1")

            var response5: GetConstantListResponse = await ConstantService.getConstantList('PRODUCT_TYPE', undefined, ProductTypeEnum.NORMAL);

            if (!response5.isSuccess) {
                toast.error(response5.message)
                return;
            }

            if (response5.data.length > 0) {
                setDefaultProductType({ label: response5.data[0].value + '', value: response5.data[0].constantId, additionalValue1: response5.data[0].additionalValue1 });
                setSelectedProductType({ label: response5.data[0].value + '', value: response5.data[0].constantId, additionalValue1: response5.data[0].additionalValue1 })
            }

            var response5: GetConstantListResponse = await ConstantService.getConstantList('ANTREPO_OUT_LOCK_REASON', undefined, "1");

            if (!response5.isSuccess) {
                toast.error(response5.message)
                return;
            }

            if (response5.data.length > 0) {
                setDefaultLockReason({ label: response5.data[0].value + '', value: response5.data[0].constantId, additionalValue1: response5.data[0].additionalValue1 });
            }

            if (id) {
                var response3: GetAntrepoOutByIdResponse = await AntrepoOutService.getAntrepoOutById(id);

                if (!response3.isSuccess) {
                    toast.error(response3.message)
                    return;
                }

                var response: GetAntrepoInByIdResponse = await AntrepoInService.getAntrepoInById(response3.data.antrepoInId);

                if (!response.isSuccess) {
                    toast.error(response.message)
                    return;
                }

                setAntrepoIn(response.data);
                setAntrepoInVehicleProducts(response.data.antrepoInVehicleProducts);

                setAntrepoOutId(response3.data.antrepoOutId);
                setAntrepoInId(response3.data.antrepoInId);

                if (response.data.receiverFirmId && response.data.receiverFirmName)
                    setSelectedReceiverFirm({ label: response.data.receiverFirmName, value: response.data.receiverFirmId });

                setLedgerNo(response3.data.ledgerNo);
                setDeclarationPotQuantity(response3.data.declarationPotQuantity);
                setDeclarationPotWeight(response3.data.declarationPotWeight);
                setAntrepoDeclarationNo(response3.data.antrepoDeclarationNo);
                setReceiptNo(response3.data.receiptNo);
                setAntrepoDeclarationDate(response3.data.antrepoDeclarationDate);
                setIsPartial(response3.data.isPartial);

                setIsLocked(response3.data.isLocked);
                setIsDisabledFromLock(response3.data.isLocked);

                if (response3.data.lockReasonId && response3.data.lockReasonName)
                    setSelectedLockReason({ label: response3.data.lockReasonName, value: response3.data.lockReasonId });
                else
                    setSelectedLockReason(undefined);

                setGoodsAmount(response3.data.goodsAmount?.toString());

                if (response3.data.goodsAmountCurrencyTypeId && response3.data.goodsAmountCurrencyTypeName)
                    setSelectedGoodsAmountCurrencyType({ label: response3.data.goodsAmountCurrencyTypeName, value: response3.data.goodsAmountCurrencyTypeId });

                setReceiptDate(response3.data.receiptDate);

                if (response3.data.senderFirmId && response3.data.senderFirmName)
                    setSelectedSenderFirm({ label: response3.data.senderFirmName, value: response3.data.senderFirmId });

                if (response3.data.exitTypeId && response3.data.exitTypeName)
                    setSelectedExitType({ label: response3.data.exitTypeName, value: response3.data.exitTypeId, additionalValue1: response3.data.exitTypeKey });

                if (response.data.customsDirectorateId && response.data.customsDirectorateName) {
                    setSelectedCustomsDirectorate({ label: response.data.customsDirectorateName, value: response.data.customsDirectorateId, additionalValue1: response.data.customsDirectorateKey });
                    setDefaultAntrepoDeclarationNo(new Date().getFullYear().toString().substring(2) + response.data.customsDirectorateKey + response3.data.exitTypeKey);
                }

                setGuaranteeAmount(response3.data.guaranteeAmount?.toString());

                if (response3.data.guaranteeAmountCurrencyTypeId && response3.data.guaranteeAmountCurrencyTypeName)
                    setSelectedGuaranteeAmountCurrencyType({ label: response3.data.guaranteeAmountCurrencyTypeName, value: response3.data.guaranteeAmountCurrencyTypeId });

                setAntrepoOutVehicles(response3.data.antrepoOutVehicles.map(function (x) {
                    if (_lastSelectedOne && x.groupNo == _lastSelectedOne)
                        x.isSelected = true;

                    return x;
                }));
                setAntrepoOutVehicleProducts(response3.data.antrepoOutVehicleProducts);
                setFileArchives(response3.data.fileArchives);
                setAntrepoOutLocks(response3.data.antrepoOutLocks)
                setAntrepoOutMessages(response3.data.antrepoOutMessages);

                // Devir Çıkış Update İşlemleri
                if (response3.data.exitTypeKey == AntrepoExitTypeEnum.DEVIR_CIKIS) {
                    setTransferAntrepoDeclarationNo(response3.data.antrepoDeclarationNo);
                    setTransferAntrepoDeclarationDate(response3.data.antrepoDeclarationDate);

                    if (response3.data.dutyFirmId && response3.data.dutyFirmName)
                        setSelectedDutyFirm({ label: response3.data.dutyFirmName, value: response3.data.dutyFirmId });

                    if (response3.data.transferFirmId && response3.data.transferFirmName)
                        setSelectedTransferFirm({ label: response3.data.transferFirmName, value: response3.data.transferFirmId });

                    setTransferWithExpenses(response3.data.transferWithExpenses);
                    setJustTransfer(response3.data.justTransfer);


                    var response6: GetAntrepoInByTransferAntrepoOutIdResponse = await AntrepoInService.getAntrepoInByTransferAntrepoOutId(response3.data.antrepoOutId);

                    if (!response6.isSuccess) {
                        toast.error(response6.message);
                        return;
                    }

                    setAntrepoOutVehicleServices(response6.data.antrepoInVehicleServices.map(function (x) {
                        var obj: GetAntrepoOutByIdResponseAntrepoOutVehicleService = {
                            antrepoOutVehicleId: x.antrepoInVehicleId,
                            antrepoOutVehicleServiceId: x.antrepoInVehicleServiceId,
                            groupNo: "1",
                            isSelected: false,
                            multiplierId: x.multiplierId,
                            multiplierName: x.multiplierName,
                            quantity: x.quantity,
                            serviceId: x.serviceId,
                            serviceName: x.serviceName,
                            willNotBeInvoiced: x.willNotBeInvoiced,
                            willNotBeInvoicedReason: x.willNotBeInvoicedReason
                        };

                        return obj;
                    }));
                }
                else {
                    setAntrepoOutVehicleServices(response3.data.antrepoOutVehicleServices);
                }
            }
            else {
                var response2: GetConstantByIdResponse = await ConstantService.getConstantById(exitTypeId + '');

                if (!response2.isSuccess) {
                    toast.error(response2.message)
                    return;
                }

                setSelectedExitType({ label: response2.data.value, value: response2.data.constantId, additionalValue1: response2.data.additionalValue1 });

                var response: GetAntrepoInByIdResponse = await AntrepoInService.getAntrepoInById(antrepoInId);

                if (!response.isSuccess) {
                    toast.error(response.message)
                    return;
                }

                setAntrepoIn(response.data);
                if (response.data.customsDirectorateId && response.data.customsDirectorateName) {
                    setSelectedCustomsDirectorate({ label: response.data.customsDirectorateName, value: response.data.customsDirectorateId, additionalValue1: response.data.customsDirectorateKey });

                    var decNo = "";

                    if (response2.data.additionalValue1 == 'LR') {
                        decNo = new Date().getFullYear().toString().substring(2) + response2.data.additionalValue1 + response.data.customsDirectorateKey;
                    }
                    else {
                        decNo = new Date().getFullYear().toString().substring(2) + response.data.customsDirectorateKey + response2.data.additionalValue1;
                    }

                    setDefaultAntrepoDeclarationNo(decNo);
                    setAntrepoDeclarationNo(decNo);

                    if (response2.data.additionalValue1 == AntrepoExitTypeEnum.DEVIR_CIKIS) {
                        setTransferAntrepoDeclarationNo(decNo);
                    }
                }

                if (response.data.receiverFirmId && response.data.receiverFirmName)
                    setSelectedReceiverFirm({ label: response.data.receiverFirmName, value: response.data.receiverFirmId });

                setAntrepoInVehicleProducts(_isPartial == "1" ? response.data.antrepoInVehicleProducts : []);

                var antrepoOutVehicleId = Helpers.generateUUID(true);

                setAntrepoOutVehicles([{
                    antrepoOutVehicleId: antrepoOutVehicleId,
                    isSelected: false,
                    containerId: undefined,
                    containerName: undefined,
                    containerNo: undefined,
                    groupNo: (antrepoOutVehicles.length == 0 ? 1 : Math.max(...antrepoOutVehicles.filter(x => x.groupNo && x.groupNo.toString().trim() != '').map(x => parseInt(x.groupNo + ''))) + 1).toString(),
                    supplierId: undefined,
                    supplierName: undefined,
                    trailerId: undefined,
                    trailerName: undefined,
                    transportDocumentNo: undefined,
                    truckReportNo: undefined,
                    vehicleArriveDate: undefined,
                    vehicleId: undefined,
                    vehicleName: undefined,
                    welcomeId: undefined,
                    isDefault: true,
                    antrepoExitDate: undefined,
                    loadingOfficerId: undefined,
                    loadingOfficerName: undefined,
                    operatorId: undefined,
                    operatorName: undefined,
                    rampId: undefined,
                    rampName: undefined,
                    driverId: undefined,
                    driverName: undefined,
                    willNotBeInvoiced: false,
                    willNotBeInvoicedReason: undefined
                }])

                setAntrepoInId(response.data.antrepoInId);
                setLedgerNo(response.data.ledgerNo);

                if (response.data.senderFirmId && response.data.senderFirmName)
                    setSelectedSenderFirm({ label: response.data.senderFirmName, value: response.data.senderFirmId });

                if (response.data.goodsAmountCurrencyTypeId && response.data.goodsAmountCurrencyTypeName)
                    setSelectedGoodsAmountCurrencyType({ label: response.data.goodsAmountCurrencyTypeName, value: response.data.goodsAmountCurrencyTypeId });

                if (response.data.guaranteeAmountCurrencyTypeId && response.data.guaranteeAmountCurrencyTypeName)
                    setSelectedGuaranteeAmountCurrencyType({ label: response.data.guaranteeAmountCurrencyTypeName, value: response.data.guaranteeAmountCurrencyTypeId });

                if (_isPartial && _isPartial == "0") {
                    setDeclarationPotQuantity(response.data.declarationPotQuantity);
                    setDeclarationPotWeight(response.data.declarationPotWeight);

                    setGoodsAmount(response.data.goodsAmount?.toString());

                    setGuaranteeAmount(response.data.guaranteeAmount?.toString());

                    setAntrepoOutVehicleProducts(response.data.antrepoInVehicleProducts.filter(x => Helpers.toNumber(x.stockPotQuantity) > 0 || Helpers.toNumber(x.stockGrossWeight) > 0 || Helpers.toNumber(x.stockNetWeight) > 0 || Helpers.toNumber(x.stockVolume) > 0 || Helpers.toNumber(x.stockArea) > 0).map(function (x) {
                        var obj: GetAntrepoOutByIdResponseAntrepoOutVehicleProduct = {
                            volume: x.stockVolume,
                            area: x.stockArea,
                            grossWeight: x.stockGrossWeight,
                            gTipId: x.gTipId,
                            gTipName: x.gTipName,
                            isSelected: false,
                            netWeight: x.stockNetWeight,
                            potQuantity: x.stockPotQuantity,
                            productTypeId: x.productTypeId,
                            productTypeName: x.productTypeName,
                            groupNo: "1",
                            antrepoOutVehicleId: antrepoOutVehicleId,
                            antrepoOutVehicleProductId: Helpers.generateUUID(true),
                            isJustInformationChange: false,
                            productLocationId: x.productLocationId,
                            productLocationName: x.productLocationName,
                            productKindId: x.productKindId,
                            productKindName: x.productKindName,
                            potTypeId: x.potTypeId,
                            potTypeName: x.potTypeName,
                            palletCount: x.palletCount
                        };

                        return obj;
                    }))
                }

                // Devir Çıkış Yeni Giriş İşlemleri
                if (response2.data.additionalValue1 == AntrepoExitTypeEnum.DEVIR_CIKIS) {
                    // setTransferAntrepoDeclarationDate(response.data.antrepoDeclarationDate);
                    setTransferAntrepoDeclarationDate(moment().format('YYYY-MM-DDTHH:mm'));

                    if (response.data.dutyFirmId && response.data.dutyFirmName)
                        setSelectedDutyFirm({ label: response.data.dutyFirmName, value: response.data.dutyFirmId });

                    setAntrepoOutVehicleServices(response.data.antrepoInVehicleServices.filter(x => Helpers.isEmpty(x.lastInvoicedDate)).map(function (x) {
                        var obj: GetAntrepoOutByIdResponseAntrepoOutVehicleService = {
                            antrepoOutVehicleId: Helpers.generateUUID(),
                            antrepoOutVehicleServiceId: Helpers.generateUUID(),
                            groupNo: "1",
                            isSelected: false,
                            multiplierId: x.multiplierId,
                            multiplierName: x.multiplierName,
                            quantity: x.quantity,
                            serviceId: x.serviceId,
                            serviceName: x.serviceName,
                            willNotBeInvoiced: x.willNotBeInvoiced,
                            willNotBeInvoicedReason: x.willNotBeInvoicedReason
                        };

                        return obj;
                    }))
                }
            }
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    const lockRecord = () => {
        if (!selectedLockReason) {
            toast.error('Kilit Nedeni Seçiniz!')
            return;
        }

        saveAntrepoOut(undefined, true, undefined, true)
    }

    const unlockRecord = () => {
        if (Helpers.isEmpty(unlockReason)) {
            toast.error('Kilit Açma Açıklaması Giriniz!')
            return;
        }

        saveAntrepoOut(undefined, true, undefined, false)
    }

    const stockValidations = async (_outProduct: GetAntrepoOutByIdResponseAntrepoOutVehicleProduct) => {
        var allStockProducts = antrepoInVehicleProducts.filter(x => Helpers.toNumber(x.stockPotQuantity) > 0 || Helpers.toNumber(x.stockGrossWeight) > 0 || Helpers.toNumber(x.stockNetWeight) > 0 || Helpers.toNumber(x.stockVolume) > 0 || Helpers.toNumber(x.stockArea) > 0);
        var outProducts = [...new Set([_outProduct].map(x => x.gTipId))];
        var stockProducts = [...new Set(allStockProducts.map(x => x.gTipId))];

        if (!isPartial && !_outProduct.isJustInformationChange) {
            if (!(outProducts.sort().join(',') === stockProducts.sort().join(','))) {
                toast.error('Komple Çıkış işleminde stoktaki ürünler dışında bir ürün ekleyemez veya çıkartamazsınız!')
                return false;
            }
        }

        var outProdocutsSum: InOutModel[] = [];

        for (var i = 0; i < outProducts.length; i++) {
            var potQuantitySum = Helpers.sumOfNumbers(([_outProduct]).filter(x => x.gTipId == outProducts[i]).filter(x => x.potQuantity).map(x => Helpers.toNumber(x.potQuantity)));
            var grossWeightSum = Helpers.sumOfNumbers(([_outProduct]).filter(x => x.gTipId == outProducts[i]).filter(x => x.grossWeight).map(x => Helpers.toNumber(x.grossWeight)));
            var netWeightSum = Helpers.sumOfNumbers(([_outProduct]).filter(x => x.gTipId == outProducts[i]).filter(x => x.netWeight).map(x => Helpers.toNumber(x.netWeight)));
            var volumeSum = Helpers.sumOfNumbers(([_outProduct]).filter(x => x.gTipId == outProducts[i]).filter(x => x.volume).map(x => Helpers.toNumber(x.volume)));
            var areaSum = Helpers.sumOfNumbers(([_outProduct]).filter(x => x.gTipId == outProducts[i]).filter(x => x.area).map(x => Helpers.toNumber(x.area)));

            outProdocutsSum.push({
                gTipId: outProducts[i],
                potQuantitySum: potQuantitySum,
                grossWeightSum: grossWeightSum,
                netWeightSum: netWeightSum,
                volumeSum: volumeSum,
                areaSum: areaSum
            })
        }

        var stockProdocutsSum: InOutModel[] = [];

        for (var i = 0; i < stockProducts.length; i++) {
            var potQuantitySum = Helpers.sumOfNumbers(allStockProducts.filter(x => x.gTipId == stockProducts[i]).filter(x => x.stockPotQuantity).map(x => Helpers.toNumber(x.stockPotQuantity)));
            var grossWeightSum = Helpers.sumOfNumbers(allStockProducts.filter(x => x.gTipId == stockProducts[i]).filter(x => x.stockGrossWeight).map(x => Helpers.toNumber(x.stockGrossWeight)));
            var netWeightSum = Helpers.sumOfNumbers(allStockProducts.filter(x => x.gTipId == stockProducts[i]).filter(x => x.stockNetWeight).map(x => Helpers.toNumber(x.stockNetWeight)));
            var volumeSum = Helpers.sumOfNumbers(allStockProducts.filter(x => x.gTipId == stockProducts[i]).filter(x => x.stockVolume).map(x => Helpers.toNumber(x.stockVolume)));
            var areaSum = Helpers.sumOfNumbers(allStockProducts.filter(x => x.gTipId == stockProducts[i]).filter(x => x.stockArea).map(x => Helpers.toNumber(x.stockArea)));

            stockProdocutsSum.push({
                gTipId: stockProducts[i],
                potQuantitySum: potQuantitySum,
                grossWeightSum: grossWeightSum,
                netWeightSum: netWeightSum,
                volumeSum: volumeSum,
                areaSum: areaSum
            })
        }

        // if (!isPartial) {
        //     for (var i = 0; i < outProdocutsSum.length; i++) {
        //         var eq = stockProdocutsSum.find(x => x.gTipId == outProdocutsSum[i].gTipId);

        //         if (eq) {
        //             if (eq.potQuantitySum != outProdocutsSum[i].potQuantitySum || eq.grossWeightSum != outProdocutsSum[i].grossWeightSum || eq.netWeightSum != outProdocutsSum[i].netWeightSum || eq.volumeSum != outProdocutsSum[i].volumeSum || eq.areaSum != outProdocutsSum[i].areaSum) {
        //                 toast.error('Komple Çıkış işleminde stoktaki ürünlerden farklı sayılarda çıkış yapamazsınız!');
        //                 return false;
        //             }
        //         }
        //         else {
        //             toast.error('Komple Çıkış işleminde stoktaki ürünler dışında bir ürün ekleyemez veya çıkartamazsınız!');
        //             return false;
        //         }
        //     }
        // }
        // else {
        for (var i = 0; i < outProdocutsSum.length; i++) {
            var eq = stockProdocutsSum.find(x => x.gTipId == outProdocutsSum[i].gTipId);

            if (eq) {
                if (eq.potQuantitySum < outProdocutsSum[i].potQuantitySum || eq.grossWeightSum < outProdocutsSum[i].grossWeightSum || eq.netWeightSum < outProdocutsSum[i].netWeightSum || eq.volumeSum < outProdocutsSum[i].volumeSum || eq.areaSum < outProdocutsSum[i].areaSum) {
                    toast.error('Stoktaki ürünlerden daha büyük miktarlarda çıkış yapamazsınız!');
                    return false;
                }
            }
            else {
                if (!_outProduct.isJustInformationChange) {
                    toast.error('Stoktaki ürünler dışında bir ürün ekleyemezsiniz!');
                    return false;
                }
            }
        }
        // }

        return true;
    }

    const saveValidations = async (isLastStep: boolean) => {
        if (Helpers.isEmpty(antrepoDeclarationNo)) {
            toast.error('Çıkış Antrepo Beyan No alanını doldurunuz!')
            return false;
        }
        else if (selectedExitType?.additionalValue1 != AntrepoExitTypeEnum.DEVIR_CIKIS && Helpers.isEmpty(receiptNo)) {
            toast.error('Makbuz No alanını doldurunuz!')
            return false;
        }
        else if (selectedExitType?.additionalValue1 != AntrepoExitTypeEnum.DEVIR_CIKIS && Helpers.isEmpty(receiptDate)) {
            toast.error('Makbuz Tarihi alanını doldurunuz!')
            return false;
        }
        else if (Helpers.isEmpty(goodsAmount) || !selectedGoodsAmountCurrencyType) {
            toast.error('Mal Değeri alanını doldurunuz!')
            return false;
        }
        // else if (!selectedSenderFirm) {
        //     toast.error('Gönderici Firma alanını doldurunuz!');
        //     return false;
        // }
        else if (Helpers.isEmpty(guaranteeAmount) || !selectedGuaranteeAmountCurrencyType) {
            toast.error('Teminat Bedeli alanını doldurunuz!')
            return false;
        }
        else if (selectedExitType?.additionalValue1 != AntrepoExitTypeEnum.DEVIR_CIKIS && Helpers.isEmpty(antrepoDeclarationDate)) {
            toast.error('Çıkış Antrepo Beyan Tarihi alanını doldurunuz!')
            return false;
        }
        else if (!Helpers.isEmpty(antrepoDeclarationDate) && moment(antrepoDeclarationDate, 'YYYY-MM-DDTHH:mm') > moment()) {
            toast.error('Çıkış Antrepo Beyan Tarihi alanını sistem tarihinden büyük olamaz!')
            return false;
        }
        else if (Helpers.isEmpty(declarationPotQuantity)) {
            toast.error('Beyan Kap Adet alanını doldurunuz!')
            return false;
        }
        else if (Helpers.isEmpty(declarationPotWeight)) {
            toast.error('Beyan Kap Ağırlık (Kg) alanını doldurunuz!')
            return false;
        }
        else if (Helpers.toNumber(declarationPotQuantity) < 0) {
            toast.error('Beyan Kap Adet alanı negatif olamaz!')
            return false;
        }
        else if (Helpers.toNumber(declarationPotWeight) < 0) {
            toast.error('Beyan Kap Ağırlık (Kg) alanı negatif olamaz!')
            return false;
        }

        if (isPartial && isLastStep) {
            dispatch(storeActivityIndicator(true));

            var response3: GetAntrepoInByIdResponse = await AntrepoInService.getAntrepoInById(antrepoInId + '');

            if (!response3.isSuccess) {
                toast.error(response3.message);
                dispatch(storeActivityIndicator(false));
                return false;
            }

            var response2: GetAntrepoOutListByAntrepoInIdResponse = await AntrepoOutService.getAntrepoOutListByAntrepoInId(antrepoInId + '');

            if (!response2.isSuccess) {
                toast.error(response2.message);
                dispatch(storeActivityIndicator(false));
                return false;
            }

            if (antrepoOutId)
                response2.data = response2.data.filter(x => x.antrepoOutId != antrepoOutId);

            if (selectedGoodsAmountCurrencyType?.value != response3.data.goodsAmountCurrencyTypeId) {
                toast.error('Mal Değeri para birimi ' + response3.data.goodsAmountCurrencyTypeName + ' olmalıdır.');
                dispatch(storeActivityIndicator(false));
                return false;
            }

            if (selectedGuaranteeAmountCurrencyType?.value != response3.data.guaranteeAmountCurrencyTypeId) {
                toast.error('Teminat Bedeli para birimi ' + response3.data.guaranteeAmountCurrencyTypeName + ' olmalıdır.');
                dispatch(storeActivityIndicator(false));
                return false;
            }

            if (response2.data.length == 0 && antrepoInVehicleProducts.filter(x => Helpers.toNumber(x.stockPotQuantity) > 0 || Helpers.toNumber(x.stockGrossWeight) > 0 || Helpers.toNumber(x.stockNetWeight) > 0 || Helpers.toNumber(x.stockVolume) > 0 || Helpers.toNumber(x.stockArea) > 0).length == 0) {
                toast.error('Düşümlü çıkış işlemlerinde tek bir çıkış işleminde stok sıfırlanamaz!');
                dispatch(storeActivityIndicator(false));
                return false;
            }

            var goodsAmountSum = Helpers.sumOfNumbers(response2.data.filter(x => x.goodsAmount).map(x => Helpers.toNumber(x.goodsAmount))) + Helpers.toNumber(goodsAmount);

            if (response3.data.goodsAmount && goodsAmountSum > Helpers.toNumber(response3.data.goodsAmount)) {
                toast.error('Mal Değeri çıkış toplamları giriş değerini geçemez!');
                dispatch(storeActivityIndicator(false));
                return false;
            }
            else if (antrepoOutVehicleProducts.length > 0 && antrepoInVehicleProducts.filter(x => Helpers.toNumber(x.stockPotQuantity) > 0 || Helpers.toNumber(x.stockGrossWeight) > 0 || Helpers.toNumber(x.stockNetWeight) > 0 || Helpers.toNumber(x.stockVolume) > 0 || Helpers.toNumber(x.stockArea) > 0).length == 0 && response3.data.goodsAmount && goodsAmountSum != Helpers.toNumber(response3.data.goodsAmount)) {
                toast.error('Stok sıfırlanıyor ise çıkışlardaki toplam Mal Değeri, girişteki Mal Değerine eşit olmalıdır!');
                dispatch(storeActivityIndicator(false));
                return false;
            }
            else if (response3.data.goodsAmount && goodsAmountSum == Helpers.toNumber(response3.data.goodsAmount) && response2.data.length == 0) {
                toast.error('Düşümlü çıkış işlemlerinde tek bir çıkış işleminde Mal Değeri sıfırlanamaz!');
                dispatch(storeActivityIndicator(false));
                return false;
            }

            var guaranteeAmountSum = Helpers.sumOfNumbers(response2.data.filter(x => x.guaranteeAmount).map(x => Helpers.toNumber(x.guaranteeAmount))) + Helpers.toNumber(guaranteeAmount);

            if (response3.data.guaranteeAmount && guaranteeAmountSum > Helpers.toNumber(response3.data.guaranteeAmount)) {
                toast.error('Teminat Bedeli çıkış toplamları giriş değerini geçemez!');
                dispatch(storeActivityIndicator(false));
                return false;
            }
            else if (antrepoOutVehicleProducts.length > 0 && antrepoInVehicleProducts.filter(x => Helpers.toNumber(x.stockPotQuantity) > 0 || Helpers.toNumber(x.stockGrossWeight) > 0 || Helpers.toNumber(x.stockNetWeight) > 0 || Helpers.toNumber(x.stockVolume) > 0 || Helpers.toNumber(x.stockArea) > 0).length == 0 && response3.data.guaranteeAmount && guaranteeAmountSum != Helpers.toNumber(response3.data.guaranteeAmount)) {
                toast.error('Stok sıfırlanıyor ise çıkışlardaki toplam Teminat Bedeli, girişteki Mal Teminat Bedeline eşit olmalıdır!');
                dispatch(storeActivityIndicator(false));
                return false;
            }
            else if (response3.data.guaranteeAmount && guaranteeAmountSum == Helpers.toNumber(response3.data.guaranteeAmount) && response2.data.length == 0) {
                toast.error('Düşümlü çıkış işlemlerinde tek bir çıkış işleminde Teminat Bedeli sıfırlanamaz!');
                dispatch(storeActivityIndicator(false));
                return false;
            }

            var declarationPotQuantitySum = Helpers.sumOfNumbers(response2.data.filter(x => x.declarationPotQuantity).map(x => Helpers.toNumber(x.declarationPotQuantity))) + Helpers.toNumber(declarationPotQuantity);

            if (response3.data.declarationPotQuantity && declarationPotQuantitySum > Helpers.toNumber(response3.data.declarationPotQuantity)) {
                toast.error('Beyan Kap Adet çıkış toplamları giriş değerini geçemez!');
                dispatch(storeActivityIndicator(false));
                return false;
            }
            else if (antrepoOutVehicleProducts.length > 0 && antrepoInVehicleProducts.filter(x => Helpers.toNumber(x.stockPotQuantity) > 0 || Helpers.toNumber(x.stockGrossWeight) > 0 || Helpers.toNumber(x.stockNetWeight) > 0 || Helpers.toNumber(x.stockVolume) > 0 || Helpers.toNumber(x.stockArea) > 0).length == 0 && response3.data.declarationPotQuantity && declarationPotQuantitySum != Helpers.toNumber(response3.data.declarationPotQuantity)) {
                toast.error('Stok sıfırlanıyor ise çıkışlardaki toplam Beyan Kap Adet, girişteki Beyan Kap Adetine eşit olmalıdır!');
                dispatch(storeActivityIndicator(false));
                return false;
            }
            else if (response3.data.declarationPotQuantity && declarationPotQuantitySum == Helpers.toNumber(response3.data.declarationPotQuantity) && response2.data.length == 0) {
                toast.error('Düşümlü çıkış işlemlerinde tek bir çıkış işleminde Beyan Kap Adet sıfırlanamaz!');
                dispatch(storeActivityIndicator(false));
                return false;
            }

            var declarationPotWeightSum = Helpers.sumOfNumbers(response2.data.filter(x => x.declarationPotWeight).map(x => Helpers.toNumber(x.declarationPotWeight))) + Helpers.toNumber(declarationPotWeight);

            if (response3.data.declarationPotWeight && declarationPotWeightSum > Helpers.toNumber(response3.data.declarationPotWeight)) {
                toast.error('Beyan Kap Ağırlık (Kg) çıkış toplamları giriş değerini geçemez!');
                dispatch(storeActivityIndicator(false));
                return false;
            }
            else if (antrepoOutVehicleProducts.length > 0 && antrepoInVehicleProducts.filter(x => Helpers.toNumber(x.stockPotQuantity) > 0 || Helpers.toNumber(x.stockGrossWeight) > 0 || Helpers.toNumber(x.stockNetWeight) > 0 || Helpers.toNumber(x.stockVolume) > 0 || Helpers.toNumber(x.stockArea) > 0).length == 0 && response3.data.declarationPotWeight && declarationPotWeightSum != Helpers.toNumber(response3.data.declarationPotWeight)) {
                toast.error('Stok sıfırlanıyor ise çıkışlardaki toplam Beyan Kap Ağırlık (Kg), girişteki Beyan Kap Ağırlık (Kg) eşit olmalıdır!');
                dispatch(storeActivityIndicator(false));
                return false;
            }
            else if (response3.data.declarationPotWeight && declarationPotWeightSum == Helpers.toNumber(response3.data.declarationPotWeight) && response2.data.length == 0) {
                toast.error('Düşümlü çıkış işlemlerinde tek bir çıkış işleminde Beyan Kap Ağırlık (Kg) sıfırlanamaz!');
                dispatch(storeActivityIndicator(false));
                return false;
            }

            // if (antrepoOutVehicleProducts.length > 0) {
            //     var controlList = getStockGroupedList().filter(x => Helpers.toNumber(x.stockPotQuantity) > 0 || Helpers.toNumber(x.stockGrossWeight) > 0 || Helpers.toNumber(x.stockNetWeight) > 0 || Helpers.toNumber(x.stockVolume) > 0 || Helpers.toNumber(x.stockArea) > 0);

            //     for (var i = 0; i < controlList.length; i++) {
            //         if (Helpers.toNumber(controlList[i].stockPotQuantity) == 0 || Helpers.toNumber(controlList[i].stockGrossWeight) == 0 || Helpers.toNumber(controlList[i].stockNetWeight) == 0 || Helpers.toNumber(controlList[i].stockVolume) == 0 || Helpers.toNumber(controlList[i].stockArea) == 0) {
            //             if (Helpers.toNumber(controlList[i].stockPotQuantity) > 0 || Helpers.toNumber(controlList[i].stockGrossWeight) > 0 || Helpers.toNumber(controlList[i].stockNetWeight) > 0 || Helpers.toNumber(controlList[i].stockVolume) > 0 || Helpers.toNumber(controlList[i].stockArea) > 0) {
            //                 toast.error('Düşümlü çıkış işlemlerinde bir alan sıfırlandığında diğer alanlar da sıfırlanmalıdır!');
            //                 dispatch(storeActivityIndicator(false));
            //                 return false;
            //             }
            //         }
            //     }
            // }
        }

        return true;
    }

    const getStockGroupedList = () => {
        var noRefList: GetAntrepoInByIdResponseAntrepoInVehicleProduct[] = JSON.parse(JSON.stringify(antrepoInVehicleProducts));

        noRefList = noRefList.filter(x => Helpers.toNumber(x.stockPotQuantity) > 0
            || Helpers.toNumber(x.stockGrossWeight) > 0
            || Helpers.toNumber(x.stockNetWeight) > 0
            || Helpers.toNumber(x.stockVolume) > 0
            || Helpers.toNumber(x.stockArea) > 0);

        if (noRefList.length == 0)
            return [];

        var newList: GetAntrepoInByIdResponseAntrepoInVehicleProduct[] = [];

        for (var i = 0; i < noRefList.length; i++) {
            var findObj = newList.find(x => x.gTipId == noRefList[i].gTipId && Helpers.toNumber(x.daysInStorage) == Helpers.toNumber(noRefList[i].daysInStorage) && x.productTypeId == noRefList[i].productTypeId);

            if (findObj) {
                findObj.stockPotQuantity = (Helpers.toNumber(findObj.stockPotQuantity) + Helpers.toNumber(noRefList[i].stockPotQuantity)).toString();
                findObj.stockGrossWeight = (Helpers.toNumber(findObj.stockGrossWeight) + Helpers.toNumber(noRefList[i].stockGrossWeight)).toString();
                findObj.stockNetWeight = (Helpers.toNumber(findObj.stockNetWeight) + Helpers.toNumber(noRefList[i].stockNetWeight)).toString();
                findObj.stockVolume = (Helpers.toNumber(findObj.stockVolume) + Helpers.toNumber(noRefList[i].stockVolume)).toString();
                findObj.stockArea = (Helpers.toNumber(findObj.stockArea) + Helpers.toNumber(noRefList[i].stockArea)).toString();
            }
            else {
                newList.push({
                    ...noRefList[i],
                    daysInStorage: noRefList[i].daysInStorage,
                    gTipName: noRefList[i].gTipName,
                    productTypeName: noRefList[i].productTypeName,
                    stockPotQuantity: noRefList[i].stockPotQuantity,
                    stockGrossWeight: noRefList[i].stockGrossWeight,
                    stockNetWeight: noRefList[i].stockNetWeight,
                    stockVolume: noRefList[i].stockVolume,
                    stockArea: noRefList[i].stockArea,
                })
            }
        }

        return newList;
    }

    const saveAntrepoOut = async (_antrepoOutVehicleProducts: GetAntrepoOutByIdResponseAntrepoOutVehicleProduct[] | undefined = undefined, isLastStep: boolean = false, _antrepoOutVehicles: GetAntrepoOutByIdResponseAntrepoOutVehicle[] | undefined = undefined, _isLocked: boolean | undefined = undefined) => {
        try {
            var _selectedLockReason = selectedLockReason;

            if (selectedExitType?.additionalValue1 != AntrepoExitTypeEnum.DEVIR_CIKIS && isLastStep && !isPartial && (_antrepoOutVehicles ? _antrepoOutVehicles : antrepoOutVehicles).length > 0 && antrepoInVehicleProducts.filter(x => Helpers.toNumber(x.stockPotQuantity) > 0 || Helpers.toNumber(x.stockGrossWeight) > 0 || Helpers.toNumber(x.stockNetWeight) > 0 || Helpers.toNumber(x.stockVolume) > 0 || Helpers.toNumber(x.stockArea) > 0).length > 0) {
                toast.error('Komple çıkış işleminde stok kalmamalıdır!');
                dispatch(storeActivityIndicator(false));
                return false;
            }
            else if (!await saveValidations(isLastStep)) {
                dispatch(storeActivityIndicator(false));
                return false;
            }
            else {
                if (isLastStep) {
                    for (var i = 0; i < (_antrepoOutVehicleProducts ? _antrepoOutVehicleProducts : antrepoOutVehicleProducts).length; i++) {
                        var vehicle = (_antrepoOutVehicles ? _antrepoOutVehicles : antrepoOutVehicles).find(x => x.groupNo == (_antrepoOutVehicleProducts ? _antrepoOutVehicleProducts : antrepoOutVehicleProducts)[i].groupNo);

                        if (!vehicle || (Helpers.isEmpty((_antrepoOutVehicleProducts ? _antrepoOutVehicleProducts : antrepoOutVehicleProducts)[i].productLocationId) && !Helpers.isEmpty(vehicle.antrepoExitDate))) {
                            toast.error('Antrepo Çıkış Tarihi doldurulmuş tüm araçların ürünleri için Ürün Lokasyonu alanı dolu olmalıdır!');
                            dispatch(storeActivityIndicator(false));
                            return false;
                        }
                    }
                }

                if ((_antrepoOutVehicleProducts ? _antrepoOutVehicleProducts : antrepoOutVehicleProducts).length > 0) {
                    if (isLastStep && (_antrepoOutVehicles ? _antrepoOutVehicles : antrepoOutVehicles).filter(x => Helpers.isEmpty(x.antrepoExitDate)).length == 0) {
                        if (Helpers.sumOfNumbers((_antrepoOutVehicleProducts ? _antrepoOutVehicleProducts : antrepoOutVehicleProducts).filter(x => x.potQuantity).map(x => Helpers.toNumber(x.potQuantity))) != Helpers.toNumber(declarationPotQuantity)) {
                            if (!antrepoOutLocks.find(x => x.lockReasonKey == "1")) {
                                toast('Beyan Kap Adet çıkış Kap Adet alanına eşit değildir, kayıt kilitlenmiştir!', {
                                    icon: <i className="fa text-warning fa-exclamation-triangle fs-1 text-primary" />
                                })

                                _isLocked = true;
                                _selectedLockReason = defaultLockReason;
                            }
                        }
                    }

                    if (isLastStep && (_antrepoOutVehicles ? _antrepoOutVehicles : antrepoOutVehicles).filter(x => Helpers.isEmpty(x.antrepoExitDate)).length == 0) {
                        if (Helpers.sumOfNumbers((_antrepoOutVehicleProducts ? _antrepoOutVehicleProducts : antrepoOutVehicleProducts).filter(x => x.grossWeight).map(x => Helpers.toNumber(x.grossWeight))) != Helpers.toNumber(declarationPotWeight)) {
                            if (!antrepoOutLocks.find(x => x.lockReasonKey == "1")) {
                                toast('Beyan Kap Ağırlık çıkış Kap Ağırlık alanına eşit değildir, kayıt kilitlenmiştir!', {
                                    icon: <i className="fa text-warning fa-exclamation-triangle fs-1 text-primary" />
                                })

                                _isLocked = true;
                                _selectedLockReason = defaultLockReason;
                            }
                        }
                    }
                }

                dispatch(storeActivityIndicator(true));

                if (selectedExitType?.additionalValue1 == AntrepoExitTypeEnum.DEVIR_CIKIS) {
                    saveAntrepoTransfer(antrepoOutId, undefined, (_antrepoOutVehicleProducts ? _antrepoOutVehicleProducts : antrepoOutVehicleProducts), isLastStep);
                    return true;
                }

                var obj: AddAntrepoOutRequest = {
                    antrepoOutId: antrepoOutId,
                    antrepoDeclarationNo: selectedExitType?.additionalValue1 == AntrepoExitTypeEnum.DEVIR_CIKIS ? transferAntrepoDeclarationNo : antrepoDeclarationNo,
                    goodsAmount: goodsAmount,
                    goodsAmountCurrencyTypeId: selectedGoodsAmountCurrencyType?.value,
                    antrepoDeclarationDate: selectedExitType?.additionalValue1 == AntrepoExitTypeEnum.DEVIR_CIKIS ? transferAntrepoDeclarationDate : antrepoDeclarationDate,
                    guaranteeAmount: guaranteeAmount,
                    guaranteeAmountCurrencyTypeId: selectedGuaranteeAmountCurrencyType?.value,
                    senderFirmId: selectedReceiverFirm?.value,
                    receiverFirmId: selectedSenderFirm?.value,
                    antrepoOutVehicles: (_antrepoOutVehicles ? _antrepoOutVehicles : antrepoOutVehicles).map(function (x) {
                        var obj2: AddAntrepoOutRequestAntrepoOutVehicle = {
                            antrepoOutVehicleId: x.antrepoOutVehicleId.startsWith('newrecrd') ? undefined : x.antrepoOutVehicleId,
                            containerId: x.containerId,
                            containerNo: x.containerNo,
                            groupNo: x.groupNo,
                            supplierId: x.supplierId,
                            trailerId: x.trailerId,
                            transportDocumentNo: x.transportDocumentNo,
                            truckReportNo: x.truckReportNo,
                            vehicleArriveDate: x.vehicleArriveDate,
                            vehicleId: x.vehicleId,
                            welcomeId: x.welcomeId,
                            antrepoExitDate: x.antrepoExitDate,
                            isDefault: x.vehicleId ? 0 : x.isDefault ? 1 : 0,
                            loadingOfficerId: x.loadingOfficerId,
                            operatorId: x.operatorId,
                            rampId: x.rampId,
                            driverId: x.driverId,
                            willNotBeInvoiced: x.willNotBeInvoiced ? 1 : 0,
                            willNotBeInvoicedReason: x.willNotBeInvoicedReason
                        };

                        return obj2;
                    }),
                    antrepoOutVehicleProducts: (_antrepoOutVehicleProducts ? _antrepoOutVehicleProducts : antrepoOutVehicleProducts).map(function (x) {
                        var obj2: AddAntrepoOutRequestAntrepoOutVehicleProduct = {
                            antrepoOutVehicleProductId: x.antrepoOutVehicleProductId.startsWith('newrecrd') ? undefined : x.antrepoOutVehicleProductId,
                            antrepoOutVehicleId: x.antrepoOutVehicleId.startsWith('newrecrd') ? undefined : x.antrepoOutVehicleId,
                            area: x.area,
                            grossWeight: x.grossWeight,
                            groupNo: x.groupNo,
                            gTipId: x.gTipId,
                            netWeight: x.netWeight,
                            potQuantity: x.potQuantity,
                            productTypeId: x.productTypeId,
                            volume: x.volume,
                            productLocationId: x.productLocationId,
                            potTypeId: x.potTypeId,
                            productKindId: x.productKindId,
                            palletCount: x.palletCount
                        };

                        return obj2;
                    }),
                    antrepoOutVehicleServices: antrepoOutVehicleServices.map(function (x) {
                        return {
                            antrepoOutVehicleServiceId: x.antrepoOutVehicleServiceId.startsWith('newrecrd') ? undefined : x.antrepoOutVehicleServiceId,
                            antrepoOutVehicleId: x.antrepoOutVehicleId.startsWith('newrecrd') ? undefined : x.antrepoOutVehicleId,
                            groupNo: x.groupNo,
                            multiplierId: x.multiplierId,
                            quantity: x.quantity,
                            serviceId: x.serviceId,
                            willNotBeInvoiced: x.willNotBeInvoiced ? 1 : 0,
                            willNotBeInvoicedReason: x.willNotBeInvoicedReason
                        }
                    }),
                    fileArchives: fileArchives.map(function (x) {
                        return {
                            description: x.description,
                            entityId: x.entityId,
                            file: x.fileArchiveFile,
                            fileName: x.fileName,
                            fileTypeId: x.fileTypeId,
                            fileArchiveId: x.fileArchiveId
                        }
                    }),
                    antrepoInId: antrepoInId,
                    receiptDate: receiptDate,
                    receiptNo: receiptNo,
                    isPartial: isPartial ? 1 : 0,
                    declarationPotQuantity: declarationPotQuantity,
                    declarationPotWeight: declarationPotWeight,
                    exitTypeId: selectedExitType?.value,
                    isLocked: Helpers.isEmpty(_isLocked) ? (isLocked ? 1 : 0) : (_isLocked ? 1 : 0),
                    lockReasonId: (Helpers.isEmpty(_isLocked) ? (isLocked ? 1 : 0) : (_isLocked ? 1 : 0)) ? _selectedLockReason?.value : undefined,
                    unlockReason: (Helpers.isEmpty(_isLocked) ? (isLocked ? 1 : 0) : (_isLocked ? 1 : 0)) ? undefined : unlockReason,
                    transferFirmId: undefined,
                    justTransfer: 0,
                    transferWithExpenses: 0,
                    dutyFirmId: undefined,
                }

                setSelectedLockReason(undefined);
                setUnlockReason('');

                var lastSelectedOne = antrepoOutVehicles.find(x => x.isSelected)?.groupNo;

                var response: AddAntrepoOutResponse = await AntrepoOutService.addAntrepoOut(obj);

                if (!response.isSuccess) {
                    toast.error(response.message);
                    dispatch(storeActivityIndicator(false));
                    return false;
                }

                if (!_antrepoOutVehicleProducts && !_antrepoOutVehicles && (Helpers.isEmpty(_isLocked) || (!Helpers.isEmpty(_isLocked) && _isLocked == true))) {
                    toast.success(response.message);
                    navigate(Helpers.getGoBackUrl());
                }
                else {
                    getData(response.data.antrepoOutId, lastSelectedOne);
                }
                return true;
            }
        } catch (error: any) {
            toast.error(error);
            dispatch(storeActivityIndicator(false));
            return false;
        }
    }

    const saveAntrepoTransfer = async (_antrepoOutId: string | undefined, response3: AddAntrepoOutResponse | undefined, _antrepoOutVehicleProducts: GetAntrepoOutByIdResponseAntrepoOutVehicleProduct[] | undefined, _isLastStep: boolean) => {
        try {
            if (!selectedTransferFirm) {
                toast.error('Devredilen Firma alanı zorunludur!');
                dispatch(storeActivityIndicator(false));
                return;
            }

            if (!transferWithExpenses && !justTransfer) {
                toast.error('Masraflarla Devir veya Sadece Devir seçeneklerinden biri seçili olmalıdır!');
                dispatch(storeActivityIndicator(false));
                return;
            }


            if ((response3 ? response3.data.antrepoOutVehicleProducts : _antrepoOutVehicleProducts ? _antrepoOutVehicleProducts : antrepoOutVehicleProducts).length == 0) {
                toast.error('Düşümlü Devir Çıkış işleminde en az bir ürün girilmelidir!');
                dispatch(storeActivityIndicator(false));
                return;
            }

            dispatch(storeActivityIndicator(true));

            var response: GetAntrepoInByIdResponse = await AntrepoInService.getAntrepoInById(antrepoInId + '');

            if (!response.isSuccess) {
                toast.error(response.message);
                dispatch(storeActivityIndicator(false));
                return;
            }

            var response2: GetAntrepoOutListByAntrepoInIdResponse = await AntrepoOutService.getAntrepoOutListByAntrepoInId(antrepoInId + '');

            if (!response2.isSuccess) {
                toast.error(response2.message);
                dispatch(storeActivityIndicator(false));
                return;
            }

            var _declarationPotQuantity = _antrepoOutId ? Helpers.toNumber(declarationPotQuantity) : Helpers.toNumber(response.data.declarationPotQuantity) - Helpers.sumOfNumbers(response2.data.map(x => Helpers.toNumber(x.declarationPotQuantity)));
            var _declarationPotWeight = _antrepoOutId ? Helpers.toNumber(declarationPotWeight) : Helpers.toNumber(response.data.declarationPotWeight) - Helpers.sumOfNumbers(response2.data.map(x => Helpers.toNumber(x.declarationPotWeight)));
            var _goodsAmount = _antrepoOutId ? Helpers.toNumber(goodsAmount) : Helpers.toNumber(response.data.goodsAmount) - Helpers.sumOfNumbers(response2.data.map(x => Helpers.toNumber(x.goodsAmount)));
            var _guaranteeAmount = _antrepoOutId ? Helpers.toNumber(guaranteeAmount) : Helpers.toNumber(response.data.guaranteeAmount) - Helpers.sumOfNumbers(response2.data.map(x => Helpers.toNumber(x.guaranteeAmount)));

            var obj: AddAntrepoOutRequest = {
                antrepoOutId: _antrepoOutId,
                antrepoDeclarationNo: transferAntrepoDeclarationNo,
                goodsAmount: _goodsAmount.toFixed(2),
                goodsAmountCurrencyTypeId: selectedGoodsAmountCurrencyType?.value,
                antrepoDeclarationDate: transferAntrepoDeclarationDate,
                guaranteeAmount: _guaranteeAmount.toFixed(2),
                guaranteeAmountCurrencyTypeId: selectedGuaranteeAmountCurrencyType?.value,
                receiverFirmId: selectedTransferFirm?.value,
                senderFirmId: antrepoIn?.receiverFirmId,
                // antrepoOutVehicles: [],
                antrepoOutVehicles: (response3 ? response3.data.antrepoOutVehicles : antrepoOutVehicles).map(function (x) {
                    var antrepoInVehicleProductId = !_antrepoOutId ? undefined : response3?.data?.antrepoOutVehicleProducts?.find(a => a.antrepoOutVehicleId == x.antrepoOutVehicleId)?.antrepoInVehicleProductId;
                    var antrepoInVehicleId = !_antrepoOutId ? undefined : response.data.antrepoInVehicleProducts.find(a => a.antrepoInVehicleProductId == antrepoInVehicleProductId)?.antrepoInVehicleId;
                    var lastInvoicedDate = !_antrepoOutId ? undefined : response.data.antrepoInVehicles.find(a => a.antrepoInVehicleId == antrepoInVehicleId)?.lastInvoicedDate;
                    var antrepoEnteranceDate = !_antrepoOutId ? undefined : response.data.antrepoInVehicles.find(a => a.antrepoInVehicleId == antrepoInVehicleId)?.antrepoEnteranceDate;

                    var obj2: AddAntrepoOutRequestAntrepoOutVehicle = {
                        antrepoOutVehicleId: x.antrepoOutVehicleId?.startsWith('newrecrd') ? undefined : x.antrepoOutVehicleId,
                        containerId: x.containerId,
                        containerNo: x.containerNo,
                        groupNo: x.groupNo,
                        supplierId: x.supplierId,
                        trailerId: x.trailerId,
                        transportDocumentNo: x.transportDocumentNo,
                        truckReportNo: x.truckReportNo,
                        vehicleArriveDate: x.vehicleArriveDate,
                        vehicleId: x.vehicleId,
                        welcomeId: x.welcomeId,
                        antrepoExitDate: x.antrepoExitDate ? x.antrepoExitDate : justTransfer ? moment().format('YYYY-MM-DDTHH:mm') : !Helpers.isEmpty(lastInvoicedDate) ? lastInvoicedDate : antrepoEnteranceDate,
                        isDefault: x.vehicleId ? 0 : x.isDefault ? 1 : 0,
                        loadingOfficerId: x.loadingOfficerId,
                        operatorId: x.operatorId,
                        rampId: x.rampId,
                        driverId: x.driverId,
                        willNotBeInvoiced: x.willNotBeInvoiced ? 1 : 0,
                        willNotBeInvoicedReason: x.willNotBeInvoicedReason
                    };

                    return obj2;
                }),
                // antrepoOutVehicleProducts: [],
                antrepoOutVehicleProducts: (response3 ? response3.data.antrepoOutVehicleProducts : _antrepoOutVehicleProducts ? _antrepoOutVehicleProducts : antrepoOutVehicleProducts).map(function (x) {
                    var obj2: AddAntrepoOutRequestAntrepoOutVehicleProduct = {
                        antrepoOutVehicleProductId: x.antrepoOutVehicleProductId.startsWith('newrecrd') ? undefined : x.antrepoOutVehicleProductId,
                        antrepoOutVehicleId: x.antrepoOutVehicleId.startsWith('newrecrd') ? undefined : x.antrepoOutVehicleId,
                        area: x.area,
                        grossWeight: x.grossWeight,
                        groupNo: x.groupNo,
                        gTipId: x.gTipId,
                        netWeight: x.netWeight,
                        potQuantity: x.potQuantity,
                        productTypeId: x.productTypeId,
                        volume: x.volume,
                        productLocationId: x.productLocationId,
                        potTypeId: x.potTypeId,
                        productKindId: x.productKindId,
                        palletCount: x.palletCount
                    };

                    return obj2;
                }),
                antrepoOutVehicleServices: [],
                // antrepoOutVehicleServices: antrepoOutVehicleServices.map(function (x) {
                //     return {
                //         antrepoOutVehicleServiceId: x.antrepoOutVehicleServiceId.startsWith('newrecrd') ? undefined : x.antrepoOutVehicleServiceId,
                //         antrepoOutVehicleId: x.antrepoOutVehicleId.startsWith('newrecrd') ? undefined : x.antrepoOutVehicleId,
                //         groupNo: x.groupNo,
                //         multiplierId: x.multiplierId,
                //         quantity: x.quantity,
                //         serviceId: x.serviceId
                //     }
                // }),
                fileArchives: fileArchives.map(function (x) {
                    return {
                        description: x.description,
                        entityId: x.entityId,
                        file: x.fileArchiveFile,
                        fileName: x.fileName,
                        fileTypeId: x.fileTypeId,
                        fileArchiveId: x.fileArchiveId
                    }
                }),
                antrepoInId: antrepoInId,
                receiptDate: receiptDate,
                receiptNo: receiptNo,
                isPartial: isPartial ? 1 : 0,
                declarationPotQuantity: _declarationPotQuantity.toFixed(2),
                declarationPotWeight: _declarationPotWeight.toFixed(2),
                exitTypeId: selectedExitType?.value,
                isLocked: isLocked ? 1 : 0,
                lockReasonId: isLocked ? selectedLockReason?.value : undefined,
                unlockReason: isLocked ? undefined : unlockReason,
                transferFirmId: selectedTransferFirm?.value,
                justTransfer: justTransfer ? 1 : 0,
                transferWithExpenses: transferWithExpenses ? 1 : 0,
                dutyFirmId: selectedDutyFirm?.value,
            }

            response3 = await AntrepoOutService.addAntrepoOut(obj);

            if (!response3?.isSuccess) {
                toast.error(response3?.message + '');
                dispatch(storeActivityIndicator(false));
                return;
            }

            if (!_antrepoOutId) {
                _antrepoOutId = response3.data.antrepoOutId;
                saveAntrepoTransfer(_antrepoOutId, response3, undefined, _isLastStep);
                return;
            }

            var response5: GetAntrepoInByTransferAntrepoOutIdResponse = await AntrepoInService.getAntrepoInByTransferAntrepoOutId(response3.data.antrepoOutId);

            if (!response5.isSuccess) {
                toast.error(response5.message);
                dispatch(storeActivityIndicator(false));
                return;
            }

            var transferAntrepoInId: string | undefined = undefined;
            var transferAntrepoLedgerNo: string | undefined = undefined;

            if (response5 && response5.data && response5.data.antrepoInId) {
                transferAntrepoInId = response5.data.antrepoInId;
                transferAntrepoLedgerNo = response5.data.ledgerNo;
            }

            var obj3: AddAntrepoInRequest = {
                antrepoInId: transferAntrepoInId,
                antrepoDeclarationNo: transferAntrepoDeclarationNo,
                antrepoDeclarationDate: transferAntrepoDeclarationDate,
                goodsAmount: _goodsAmount.toFixed(2),
                goodsAmountCurrencyTypeId: selectedGoodsAmountCurrencyType?.value,
                guaranteeAmount: _guaranteeAmount.toFixed(2),
                guaranteeAmountCurrencyTypeId: selectedGuaranteeAmountCurrencyType?.value,
                saleTypeId: antrepoIn?.saleTypeId,
                antrepoId: antrepoIn?.antrepoId,
                guaranteeTypeId: antrepoIn?.guaranteeTypeId,
                receiverFirmId: selectedTransferFirm?.value,
                senderFirmId: antrepoIn?.receiverFirmId,
                dutyFirmId: selectedDutyFirm?.value,
                exitCountryId: antrepoIn?.exitCountryId,
                declarationPotQuantity: _declarationPotQuantity.toFixed(2),
                declarationPotWeight: _declarationPotWeight.toFixed(2),
                customsDirectorateId: antrepoIn?.customsDirectorateId,
                storageEnteranceDate: new Date().toISOString(),
                unlockReason: undefined,
                lockReasonId: undefined,
                isLocked: 0,
                transferAntrepoDeclarationDate: transferAntrepoDeclarationDate,
                transferFirmId: selectedTransferFirm?.value,
                transferAntrepoDeclarationNo: transferAntrepoDeclarationNo,
                transferInvoice: undefined,
                transferInvoiceFile: undefined,
                representativeId: antrepoIn?.representativeId,
                antrepoOfferId: antrepoIn?.antrepoOfferId,
                freeStorageRefNo: antrepoIn?.freeStorageRefNo,
                ledgerNo: transferAntrepoLedgerNo,
                fileArchives: [],
                antrepoInVehicles: response3.data.antrepoOutVehicles.map(function (x) {
                    var antrepoInVehicleProductId = response3?.data.antrepoOutVehicleProducts.find(a => a.antrepoOutVehicleId == x.antrepoOutVehicleId)?.antrepoInVehicleProductId;
                    var antrepoInVehicleId = response.data.antrepoInVehicleProducts.find(a => a.antrepoInVehicleProductId == antrepoInVehicleProductId)?.antrepoInVehicleId;
                    var lastInvoicedDate = response.data.antrepoInVehicles.find(a => a.antrepoInVehicleId == antrepoInVehicleId)?.lastInvoicedDate;
                    var antrepoEnteranceDate = response.data.antrepoInVehicles.find(a => a.antrepoInVehicleId == antrepoInVehicleId)?.antrepoEnteranceDate;

                    var obj: AddAntrepoInRequestAntrepoInVehicle = {
                        containerNo: x.containerNo,
                        driverId: x.driverId,
                        evacuationOfficerId: undefined,
                        groupNo: x.groupNo,
                        operatorId: x.operatorId,
                        rampId: x.rampId,
                        supplierId: x.supplierId,
                        trailerId: x.trailerId,
                        vehicleArriveDate: x.vehicleArriveDate,
                        vehicleId: x.vehicleId,
                        welcomeId: x.welcomeId,
                        antrepoEnteranceDate: justTransfer ? moment().format('YYYY-MM-DDTHH:mm') : !Helpers.isEmpty(lastInvoicedDate) ? lastInvoicedDate : antrepoEnteranceDate,
                        antrepoInVehicleId: undefined,
                        containerId: x.containerId,
                        truckReportNo: undefined,
                        transportDocumentNo: undefined,
                        summaryDeclarationDate: undefined,
                        summaryDeclarationNo: undefined,
                        summaryDeclarationOrderNo: undefined,
                        summaryDeclarationOrderQuantity: undefined
                    };

                    return obj;
                }),
                antrepoInVehicleProducts: response3.data.antrepoOutVehicleProducts.map(function (x) {
                    var obj: AddAntrepoInRequestAntrepoInVehicleProduct = {
                        antrepoInVehicleId: undefined,
                        antrepoInVehicleProductId: undefined,
                        area: x.area,
                        grossWeight: x.grossWeight,
                        groupNo: x.groupNo,
                        gTipId: x.gTipId,
                        netWeight: x.netWeight,
                        palletCount: x.palletCount,
                        potQuantity: x.potQuantity,
                        potTypeId: x.potTypeId,
                        productKindId: x.productKindId,
                        productLocationId: x.productLocationId,
                        productTypeId: x.productTypeId,
                        volume: x.volume
                    };

                    return obj;
                }),
                antrepoInVehicleServices: justTransfer ? [] : antrepoOutVehicleServices.map(function (x) {
                    var obj: AddAntrepoInRequestAntrepoInVehicleService = {
                        antrepoInVehicleId: undefined,
                        antrepoInVehicleServiceId: undefined,
                        groupNo: x.groupNo,
                        multiplierId: x.multiplierId,
                        quantity: x.quantity,
                        serviceId: x.serviceId
                    };

                    return obj;
                }),
                transferAntrepoOutId: response3.data.antrepoOutId,
                redreseAntrepoInId: antrepoIn?.redreseAntrepoInId
            }

            var response4: AddAntrepoInResponse = await AntrepoInService.addAntrepoIn(obj3);

            if (!response4.isSuccess) {
                toast.error(response4.message);
                dispatch(storeActivityIndicator(false));
                return;
            }

            if (!justTransfer && _isLastStep) {
                var response6: GetAntrepoInByIdResponse = await AntrepoInService.getAntrepoInById(antrepoInId + '');

                if (!response6.isSuccess) {
                    toast.error(response6.message);
                    dispatch(storeActivityIndicator(false));
                    return;
                }

                var obj2: AddAntrepoInRequest = {
                    antrepoDeclarationDate: response6.data.antrepoDeclarationDate,
                    antrepoDeclarationNo: response6.data.antrepoDeclarationNo,
                    antrepoId: response6.data.antrepoId,
                    antrepoInId: response6.data.antrepoInId,
                    antrepoInVehicleProducts: response6.data.antrepoInVehicleProducts,
                    antrepoInVehicles: response6.data.antrepoInVehicles.map(function (x) {
                        return {
                            ...x,
                            willNotBeInvoiced: x.willNotBeInvoiced ? 1 : 0
                        };
                    }),
                    antrepoInVehicleServices: response6.data.antrepoInVehicleServices.map(function (x) {
                        var otherQuantity = antrepoOutVehicleServices.find(a => a.serviceId == x.serviceId)?.quantity ?? "0";
                        var newQuantity = (Helpers.toNumber(x.quantity) - Helpers.toNumber(otherQuantity))
                        x.quantity = (newQuantity < 0 ? 0 : newQuantity).toFixed(2);

                        return {
                            ...x,
                            willNotBeInvoiced: x.willNotBeInvoiced ? 1 : 0
                        };
                    }),
                    antrepoOfferId: response6.data.antrepoOfferId,
                    customsDirectorateId: response6.data.customsDirectorateId,
                    declarationPotQuantity: response6.data.declarationPotQuantity,
                    declarationPotWeight: response6.data.declarationPotWeight,
                    dutyFirmId: response6.data.dutyFirmId,
                    exitCountryId: response6.data.exitCountryId,
                    fileArchives: response6.data.fileArchives,
                    freeStorageRefNo: response6.data.freeStorageRefNo,
                    goodsAmount: response6.data.goodsAmount,
                    goodsAmountCurrencyTypeId: response6.data.goodsAmountCurrencyTypeId,
                    guaranteeAmount: response6.data.guaranteeAmount,
                    guaranteeAmountCurrencyTypeId: response6.data.guaranteeAmountCurrencyTypeId,
                    guaranteeTypeId: response6.data.guaranteeTypeId,
                    isLocked: response6.data.isLocked ? 1 : 0,
                    ledgerNo: response6.data.ledgerNo,
                    lockReasonId: response6.data.lockReasonId,
                    receiverFirmId: response6.data.receiverFirmId,
                    representativeId: response6.data.representativeId,
                    saleTypeId: response6.data.saleTypeId,
                    senderFirmId: response6.data.senderFirmId,
                    storageEnteranceDate: response6.data.storageEnteranceDate,
                    transferAntrepoDeclarationDate: response6.data.transferAntrepoDeclarationDate,
                    transferAntrepoDeclarationNo: response6.data.transferAntrepoDeclarationNo,
                    transferAntrepoOutId: response6.data.transferAntrepoOutId,
                    transferFirmId: response6.data.transferFirmId,
                    transferInvoice: response6.data.transferInvoice,
                    transferInvoiceFile: undefined,
                    unlockReason: undefined,
                    redreseAntrepoInId: response6.data.redreseAntrepoInId
                }

                var response7: AddAntrepoInResponse = await AntrepoInService.addAntrepoIn(obj2);

                if (!response7.isSuccess) {
                    toast.error(response7.message);
                    dispatch(storeActivityIndicator(false));
                    return;
                }
            }

            toast.success(response4.message);

            if (_isLastStep)
                navigate(Helpers.getGoBackUrl());
            else
                getData(_antrepoOutId);
        } catch (error: any) {
            toast.error(error);
            dispatch(storeActivityIndicator(false));
        }
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={undefined} />

            <PageTitle breadcrumbs={[{
                title: (pageName + (selectedExitType ? ' - ' + selectedExitType.label : '') + (isPartial ? ' (Düşümlü) ' : ' (Komple) ')).split('>').slice(0, (pageName + (selectedExitType ? ' - ' + selectedExitType.label : '') + (isPartial ? ' (Düşümlü) ' : ' (Komple) ')).split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{((pageName + (selectedExitType ? ' - ' + selectedExitType.label : '') + (isPartial ? ' (Düşümlü) ' : ' (Komple) ')).split('>')[(pageName + (selectedExitType ? ' - ' + selectedExitType.label : '') + (isPartial ? ' (Düşümlü) ' : ' (Komple) ')).split('>').length - 1])}</PageTitle>

            <Box className="mb-10">
                <Content>
                    {
                        (selectedExitType && selectedExitType.additionalValue1 == AntrepoExitTypeEnum.DEVIR_CIKIS)
                            ?
                            (
                                <React.Fragment>
                                    <PageHeader
                                        items={[
                                            { text: 'Devir Bilgileri', ref: transferInformationRef },
                                            { text: 'Dijital Arşiv', ref: fileArchivesRef },
                                        ]}
                                    />

                                    <TransferInformation
                                        selectedTransferFirm={selectedTransferFirm}
                                        setSelectedTransferFirm={setSelectedTransferFirm}
                                        setTransferAntrepoDeclarationDate={setTransferAntrepoDeclarationDate}
                                        setTransferAntrepoDeclarationNo={setTransferAntrepoDeclarationNo}
                                        transferAntrepoDeclarationDate={transferAntrepoDeclarationDate}
                                        transferAntrepoDeclarationNo={transferAntrepoDeclarationNo}
                                        transferInformationRef={transferInformationRef}
                                        selectedDutyFirm={selectedDutyFirm}
                                        setSelectedDutyFirm={setSelectedDutyFirm}
                                        justTransfer={justTransfer}
                                        setJustTransfer={setJustTransfer}
                                        setTransferWithExpenses={setTransferWithExpenses}
                                        transferWithExpenses={transferWithExpenses}
                                        declarationPotQuantity={declarationPotQuantity}
                                        declarationPotWeight={declarationPotWeight}
                                        goodsAmount={goodsAmount}
                                        guaranteeAmount={guaranteeAmount}
                                        selectedGoodsAmountCurrencyType={selectedGoodsAmountCurrencyType}
                                        selectedGuaranteeAmountCurrencyType={selectedGuaranteeAmountCurrencyType}
                                        setDeclarationPotQuantity={setDeclarationPotQuantity}
                                        setDeclarationPotWeight={setDeclarationPotWeight}
                                        setGoodsAmount={setGoodsAmount}
                                        setGuaranteeAmount={setGuaranteeAmount}
                                        setSelectedGoodsAmountCurrencyType={setSelectedGoodsAmountCurrencyType}
                                        setSelectedGuaranteeAmountCurrencyType={setSelectedGuaranteeAmountCurrencyType}
                                        isPartial={isPartial}
                                    />

                                    {
                                        isPartial && (
                                            <React.Fragment>
                                                <VehicleInformation
                                                    antrepoOutId={antrepoOutId}
                                                    antrepoOutVehicles={antrepoOutVehicles}
                                                    setAntrepoOutVehicles={setAntrepoOutVehicles}
                                                    vehicleInformationRef={vehicleInformationRef}
                                                    welcomeList={welcomeList}
                                                    antrepoOutVehicleProducts={antrepoOutVehicleProducts}
                                                    antrepoOutVehicleServices={antrepoOutVehicleServices}
                                                    setAntrepoOutVehicleProducts={setAntrepoOutVehicleProducts}
                                                    setAntrepoOutVehicleServices={setAntrepoOutVehicleServices}
                                                    setWelcomeList={setWelcomeList}
                                                    selectedSenderFirm={selectedSenderFirm}
                                                    saveAntrepoOut={saveAntrepoOut}
                                                    selectedReceiverFirm={selectedReceiverFirm}
                                                    antrepoIn={antrepoIn}
                                                    isDisabledFromLock={isDisabledFromLock}
                                                />

                                                <ProductInformation
                                                    antrepoInVehicleProducts={antrepoInVehicleProducts}
                                                    antrepoOutVehicleProducts={antrepoOutVehicleProducts}
                                                    antrepoOutVehicles={antrepoOutVehicles}
                                                    defaultProductType={defaultProductType}
                                                    productInformationRef={productInformationRef}
                                                    selectedProductType={selectedProductType}
                                                    setAntrepoOutVehicleProducts={setAntrepoOutVehicleProducts}
                                                    setSelectedProductType={setSelectedProductType}
                                                    saveAntrepoOut={saveAntrepoOut}
                                                    stockValidations={stockValidations}
                                                    getStockGroupedList={getStockGroupedList}
                                                    antrepoIn={antrepoIn}
                                                    isPartial={isPartial}
                                                    isDisabledFromLock={isDisabledFromLock}
                                                />

                                                {
                                                    transferWithExpenses && (
                                                        <ServicesInformation
                                                            antrepoOutVehicleServices={antrepoOutVehicleServices}
                                                            antrepoOutVehicles={antrepoOutVehicles}
                                                            serviceInformationRef={serviceInformationRef}
                                                            setAntrepoOutVehicleServices={setAntrepoOutVehicleServices}
                                                            isDisabledFromLock={isDisabledFromLock}
                                                        />
                                                    )
                                                }
                                            </React.Fragment>
                                        )
                                    }

                                    <FileArchives
                                        fileArchives={fileArchives}
                                        fileArchivesRef={fileArchivesRef}
                                        setFileArchives={setFileArchives}
                                        isDisabledFromLock={isDisabledFromLock}
                                    />

                                    <KTCard className="ebbe-card mt-10">
                                        <KTCardBody>
                                            <Box flexDirection="row" justifyContent="center">
                                                <Box flexGrow={1}>&nbsp;</Box>

                                                <Box justifyContent='center'>
                                                    <button className="btn btn-sm btn-light btn-active-light-primary" onClick={() => navigate(Helpers.getGoBackUrl())}>Geri</button>
                                                </Box>

                                                {
                                                    !isDisabledFromLock && (
                                                        <Box ml="15px" justifyContent='center'>
                                                            <button className="btn btn-primary btn-sm" onClick={() => saveAntrepoOut(undefined, true)}>Kaydet</button>
                                                        </Box>
                                                    )
                                                }
                                            </Box>
                                        </KTCardBody>
                                    </KTCard>
                                </React.Fragment>
                            )
                            :
                            (
                                <React.Fragment>
                                    <PageHeader
                                        items={[
                                            { text: 'Genel Bilgiler', ref: generalInformationRef },
                                            { text: 'Araç Bilgileri', ref: vehicleInformationRef },
                                            { text: 'Ürün Bilgileri', ref: productInformationRef },
                                            { text: 'Ek Hizmetler', ref: serviceInformationRef },
                                            { text: 'Bağlı Antrepo Girişi', ref: antrepoInsRef },
                                            { text: 'Geçmiş', ref: antrepoOutMessagesRef },
                                            { text: 'Dijital Arşiv', ref: fileArchivesRef },
                                        ]}
                                    />

                                    <GeneralInformation
                                        antrepoDeclarationDate={antrepoDeclarationDate}
                                        antrepoDeclarationNo={antrepoDeclarationNo}
                                        generalInformationRef={generalInformationRef}
                                        goodsAmount={goodsAmount}
                                        guaranteeAmount={guaranteeAmount}
                                        ledgerNo={ledgerNo}
                                        selectedGoodsAmountCurrencyType={selectedGoodsAmountCurrencyType}
                                        selectedGuaranteeAmountCurrencyType={selectedGuaranteeAmountCurrencyType}
                                        setAntrepoDeclarationDate={setAntrepoDeclarationDate}
                                        setAntrepoDeclarationNo={setAntrepoDeclarationNo}
                                        setGoodsAmount={setGoodsAmount}
                                        setGuaranteeAmount={setGuaranteeAmount}
                                        setLedgerNo={setLedgerNo}
                                        setSelectedGoodsAmountCurrencyType={setSelectedGoodsAmountCurrencyType}
                                        setSelectedGuaranteeAmountCurrencyType={setSelectedGuaranteeAmountCurrencyType}
                                        receiptDate={receiptDate}
                                        receiptNo={receiptNo}
                                        selectedSenderFirm={selectedSenderFirm}
                                        setReceiptDate={setReceiptDate}
                                        setReceiptNo={setReceiptNo}
                                        setSelectedSenderFirm={setSelectedSenderFirm}
                                        isPartial={isPartial}
                                        declarationPotQuantity={declarationPotQuantity}
                                        declarationPotWeight={declarationPotWeight}
                                        setDeclarationPotQuantity={setDeclarationPotQuantity}
                                        setDeclarationPotWeight={setDeclarationPotWeight}
                                        defaultAntrepoDeclarationNo={defaultAntrepoDeclarationNo}
                                        isDisabledFromLock={isDisabledFromLock}
                                    />

                                    <VehicleInformation
                                        antrepoOutId={antrepoOutId}
                                        antrepoOutVehicles={antrepoOutVehicles}
                                        setAntrepoOutVehicles={setAntrepoOutVehicles}
                                        vehicleInformationRef={vehicleInformationRef}
                                        welcomeList={welcomeList}
                                        antrepoOutVehicleProducts={antrepoOutVehicleProducts}
                                        antrepoOutVehicleServices={antrepoOutVehicleServices}
                                        setAntrepoOutVehicleProducts={setAntrepoOutVehicleProducts}
                                        setAntrepoOutVehicleServices={setAntrepoOutVehicleServices}
                                        setWelcomeList={setWelcomeList}
                                        selectedSenderFirm={selectedSenderFirm}
                                        saveAntrepoOut={saveAntrepoOut}
                                        selectedReceiverFirm={selectedReceiverFirm}
                                        antrepoIn={antrepoIn}
                                        isDisabledFromLock={isDisabledFromLock}
                                    />

                                    <ProductInformation
                                        antrepoInVehicleProducts={antrepoInVehicleProducts}
                                        antrepoOutVehicleProducts={antrepoOutVehicleProducts}
                                        antrepoOutVehicles={antrepoOutVehicles}
                                        defaultProductType={defaultProductType}
                                        productInformationRef={productInformationRef}
                                        selectedProductType={selectedProductType}
                                        setAntrepoOutVehicleProducts={setAntrepoOutVehicleProducts}
                                        setSelectedProductType={setSelectedProductType}
                                        saveAntrepoOut={saveAntrepoOut}
                                        stockValidations={stockValidations}
                                        getStockGroupedList={getStockGroupedList}
                                        antrepoIn={antrepoIn}
                                        isPartial={isPartial}
                                        isDisabledFromLock={isDisabledFromLock}
                                    />

                                    <ServicesInformation
                                        antrepoOutVehicleServices={antrepoOutVehicleServices}
                                        antrepoOutVehicles={antrepoOutVehicles}
                                        serviceInformationRef={serviceInformationRef}
                                        setAntrepoOutVehicleServices={setAntrepoOutVehicleServices}
                                        isDisabledFromLock={isDisabledFromLock}
                                    />

                                    <AntrepoIns
                                        antrepoIn={antrepoIn}
                                        antrepoInsRef={antrepoInsRef}
                                    />

                                    <MessageHistory
                                        antrepoOutMessages={antrepoOutMessages}
                                        antrepoOutMessagesRef={antrepoOutMessagesRef}
                                    />

                                    <FileArchives
                                        fileArchives={fileArchives}
                                        fileArchivesRef={fileArchivesRef}
                                        setFileArchives={setFileArchives}
                                        isDisabledFromLock={isDisabledFromLock}
                                    />

                                    <KTCard className="ebbe-card mt-10">
                                        <KTCardBody>
                                            <Box flexDirection="row" justifyContent="center">
                                                <Box justifyContent='center'>
                                                    {
                                                        !isLocked && (
                                                            <Box flexDirection="row">
                                                                <Box width="400px" justifyContent="center">
                                                                    <CustomSingleSelect
                                                                        selectedValue={selectedLockReason}
                                                                        onChange={setSelectedLockReason}
                                                                        insertable={{
                                                                            onSubmit: { code: 'ANTREPO_OUT_LOCK_REASON' }
                                                                        }}
                                                                        onMenuOpen={() => ConstantService.getConstantList('ANTREPO_OUT_LOCK_REASON')}
                                                                        labelName='value'
                                                                        valueName='constantId'
                                                                        additionalValue1Name="additionalValue1"
                                                                        placeholder="Kilit Nedeni Seçiniz"
                                                                    />
                                                                </Box>
                                                                <Box ml="15px" justifyContent="center">
                                                                    <button className="btn btn-danger btn-sm" onClick={lockRecord}><i className="fs-6 fa fa-lock"></i>Kilitle</button>
                                                                </Box>
                                                            </Box>
                                                        )
                                                    }

                                                    {
                                                        (isLocked && auth.user.user?.data.roles.find(x => x == "Çıkış Beyan Onay") && !Helpers.isEmpty(antrepoOutId)) && (
                                                            <Box flexDirection="row">
                                                                <Box width="400px" justifyContent="center">
                                                                    <CustomTextInput placeholder="Kilit Açma Açıklaması" value={unlockReason} setValue={setUnlockReason} />
                                                                </Box>
                                                                <Box ml="15px" justifyContent="center">
                                                                    <button className="btn btn-success btn-sm" onClick={unlockRecord}><i className="fs-6 fa fa-unlock"></i>Kilidi Aç</button>
                                                                </Box>
                                                            </Box>
                                                        )
                                                    }
                                                </Box>

                                                <Box flexGrow={1}>&nbsp;</Box>

                                                <Box justifyContent='center'>
                                                    <button className="btn btn-sm btn-light btn-active-light-primary" onClick={() => navigate(Helpers.getGoBackUrl())}>Geri</button>
                                                </Box>

                                                {
                                                    !isDisabledFromLock && (
                                                        <Box ml="15px" justifyContent='center'>
                                                            <button className="btn btn-primary btn-sm" onClick={() => saveAntrepoOut(undefined, true)}>Kaydet</button>
                                                        </Box>
                                                    )
                                                }
                                            </Box>
                                        </KTCardBody>
                                    </KTCard>
                                </React.Fragment>
                            )
                    }
                </Content>
            </Box>
        </React.Fragment>
    )
}

export default AntrepoOutAdd;